export function IconArrow() {
  return (
    <svg width="12" height="9" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.57718 0.0214844L4.12846 2.56721L6.67975 0.0214844L7.46347 0.805211L4.12846 4.14022L0.793457 0.805211L1.57718 0.0214844Z"
        fill="white"
      />
    </svg>
  )
}
